export const mutations = {
  RESET: 'RESET',
  COMMIT_SHOP_INFO: 'COMMIT_SHOP_INFO',
  COMMIT_PAGE_INFO: 'COMMIT_PAGE_INFO',
};

export const actions = {
  GET_SHOP_INFO: 'getShopInfo',
  GET_PAGE_INFO: 'getPageInfo',
};
